module.exports = __webpack_public_path__ + "static/3-11ae0073873505bccf46a675289dc761.jpg";